export const SEASON = [
  // {
  //   labelTc: '全年',
  //   labelSc: '全年',
  //   labelEn: '*全年',
  //   filterKey: '全年',
  // },
  // {
  //   labelTc: '冬春季',
  //   labelSc: '冬春季',
  //   labelEn: '*冬春季',
  //   filterKey: '冬春季',
  // },
  // {
  //   labelTc: '夏季',
  //   labelSc: '夏季',
  //   labelEn: '*夏季',
  //   filterKey: '夏季',
  // },
  {
    labelTc: '春季',
    labelSc: '春季',
    labelEn: 'Spring',
    filterKey: '春季',
  },
  {
    labelTc: '夏季',
    labelSc: '夏季',
    labelEn: 'Summer',
    filterKey: '夏季',
  },
  {
    labelTc: '秋季',
    labelSc: '秋季',
    labelEn: 'Autumn',
    filterKey: '秋季',
  },
  {
    labelTc: '冬季',
    labelSc: '冬季',
    labelEn: 'Winter',
    filterKey: '冬季',
  },
];
